import { formAnatomy as parts } from "@chakra-ui/anatomy";
import {
  createMultiStyleConfigHelpers,
  cssVar,
  defineStyle
} from "@chakra-ui/styled-system";
import {
  FormControl as ChakraFormControl,
  FormControlProps
} from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const indicator = cssVar("form-control-color");

const baseStyleRequiredIndicator = defineStyle({
  marginStart: "1",
  [indicator.variable]: "colors.red.600",
  _dark: {
    [indicator.variable]: "colors.red.300"
  },
  color: indicator.reference
});

const baseStyle = definePartsStyle({
  requiredIndicator: baseStyleRequiredIndicator
});

const FormControlComponentStyle = defineMultiStyleConfig({
  baseStyle
});

const FormControl = (props: FormControlProps) => {
  return <ChakraFormControl {...props} />;
};

export { FormControl, FormControlComponentStyle };
